import axios from "axios";

export const base_api_url = "https://api2v2.wisercam.com";

// axios.interceptors.request.use((config) => {
//     console.log("==== REQUEST ====");
//     console.log(config);
//     return config;
// }, (error) => {
//     console.log("==== ERROR REQUEST ====");
//     console.log(error);
//     return Promise.reject(error);
// });

// axios.interceptors.response.use((response) => {
//     console.log("==== RESPONSE ====");
//     console.log(response);
//     return response;
// }, (error) => {
//     console.log("==== ERROR RESPONSE ====");
//     console.log(error);
//     return Promise.reject(error);
// });

const httpService = (url, method, data=null, contentType="application/json") => {    
    const token = JSON.parse(localStorage.getItem("cncToken"));
    
    return axios({
        url: base_api_url + url,
        method,
        data,
        headers: {
            "Content-Type": contentType,
            "Authorization": token ? `Bearer ${token.access}` : null
        }
    });
}


export default httpService;